export default {
  isLogin: (state) => state.login
}
